export enum EPath {
  HOME = "/*",
  LOGIN = "/login",
  PROFILE = "/profile",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  AUTH_ACTION = "/__/auth/action",
  INVITE_ADMIN_USER = "/invite-admin-user",
  SETTINGS_RESET_PASSWORD = "/settings/reset-password",
  PATIENT_MANAGEMENT = "/patient-management",
  PATIENT_DETAIL = "/patient-management/:patientId",
  VITAL_SIGNS_HISTORY = "/patient-management/:patientId/vital-signs",
  ACTIVITY_HISTORY = "/patient-management/:patientId/activity",
  SLEEP_HISTORY = "/patient-management/:patientId/sleep",
  NUTRITION_HISTORY = "/patient-management/:patientId/nutrition",
  BODY_MEASUREMENTS_HISTORY = "/patient-management/:patientId/body-measurements",
  DAILY_WELL_BEING_HISTORY = "/patient-management/:patientId/well-being/year/:lastYearChecked/month/:lastMonthChecked",
  PRACTICE_MANAGEMENT = "/practice-management",
  PRACTICE_USER_DETAIL = "/practice-management/:practiceUserId",
  PRACTICE_PROFILE = "/practice-profile",
  PRACTICE_DETAIL = "/practice-profile/:practiceId",
  PRESCRIPTION_MANAGEMENT = "/prescription-management",
  PRESCRIPTION_DETAIL = "/prescription-management/:prescriptionId",
}
